// Shared by any mock handler that needs to fabricate a JWT-shaped token (currently just oauthHandlers.ts,
// but factored out since demoModeState.ts used to duplicate this same helper before LP-2946 removed it).
export const base64Url = (value: object) =>
    btoa(JSON.stringify(value)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
